// İSG Portal — API hata modeli.
//
// Zarf (`isSuccess=false`) bir `ApiError`'a dönüştürülür. İstemci **koda göre**
// dallanır (`errorCode`), metne göre değil (api-contract §2). `message` bir resource
// code (`UPPER_SNAKE_CASE`) taşır; i18n katmanı bunu kullanıcı diline çözer.

import type { ValidationError } from './envelope';

export class ApiError extends Error {
  readonly statusCode: number;
  /** Makine-okur hata kodu (istemci dallanması için stabil sözleşme). */
  readonly errorCode: string;
  /** Alan bazlı doğrulama hataları (yalnız `VALIDATION_FAILED`'de dolu). */
  readonly errors: ValidationError[];
  /** Mesaj interpolation alan değerleri (`{{field}}`). */
  readonly messageData: Record<string, unknown> | null;

  constructor(params: {
    statusCode: number;
    errorCode: string;
    message: string;
    errors?: ValidationError[] | null;
    messageData?: Record<string, unknown> | null;
  }) {
    super(params.message);
    this.name = 'ApiError';
    this.statusCode = params.statusCode;
    this.errorCode = params.errorCode;
    this.errors = params.errors ?? [];
    this.messageData = params.messageData ?? null;
  }
}

/**
 * Ağ/parse gibi zarf üretmeyen hatalar için stabil bir sözde-kod. Gerçek backend
 * hataları her zaman zarf + `errorCode` taşır (api-contract §1).
 */
export const NETWORK_ERROR_CODE = 'NETWORK_ERROR';

/** `ApiError` mı (tip guard). */
export function isApiError(err: unknown): err is ApiError {
  return err instanceof ApiError;
}

/**
 * Sunucu isteği KESİN reddetti mi (`4xx`): istek uygulanmadı, yazma gerçekleşmedi. Ağ hatası
 * (`statusCode` 0) ya da `5xx`'te bu bilinemez — yazma kaydedilmiş, yanıt kaybolmuş olabilir; böyle
 * bir hatadan sonra "yazılmadı" varsayan telafi (ör. yüklenen dosyayı silmek) yapılmaz.
 */
export function isDefinitiveRejection(err: unknown): boolean {
  return isApiError(err) && err.statusCode >= 400 && err.statusCode < 500;
}

/** Belirli bir hata koduna sahip `ApiError` mı. */
export function hasErrorCode(err: unknown, code: string): boolean {
  return isApiError(err) && err.errorCode === code;
}
